var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTiktok = function SvgTiktok(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 22"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#tiktok_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    d: "M10.343 15.12c-.198 1.633-.972 2.43-1.774 2.728a2.4 2.4 0 0 1-.351.097q.226-.098.442-.233c.805-.51 1.406-1.369 1.683-2.593ZM5.76 8.55c-2.335.835-3.72 2.536-4.365 4.401-.55 1.588-.565 3.308-.18 4.714-1.723-3.057-.35-7.77 4.545-9.114Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.871.764c.239 1.975 1.063 3.656 2.447 4.637-1.873-.7-2.971-2.305-3.253-4.637zm4.322 5.443q.387.08.807.106v3.401c-1.755.168-3.29-.392-5.08-1.435l.275 5.825c0 1.878.008 2.736-1.032 4.464-2.332 3.877-6.53 4.183-9.37 2.337 3.713 1.485 9.333-.318 9.322-6.802V7.747c1.789 1.043 3.324 1.603 5.078 1.436zM7.491 8.665q.55-.111 1.157-.168v3.587c-1.475.236-2.412.675-2.85 1.487-1.38 2.558.397 4.586 2.384 4.891-2.31.372-5.019-1.897-3.404-4.891.438-.812 1.238-1.251 2.713-1.487z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M14.069.764c.365 3.025 2.104 4.829 5.129 5.017v3.4c-1.755.168-3.29-.392-5.08-1.435v6.358c.015 8.297-9.193 8.928-11.823 4.814-1.75-2.736-1.115-9.312 5.2-10.287v3.453c-1.475.236-2.275.675-2.713 1.487-2.707 5.018 6.735 8.004 6.083-.081V.764z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "tiktok_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v22H0z"
  })))));
};
export default SvgTiktok;